"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _InlineLoader = _interopRequireDefault(require("../../InlineLoader"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _Tick = _interopRequireDefault(require("../../Icons/Tick"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-family: galano-bold, galano, sans-serif;\n\tcursor: pointer;\n\tborder-radius: ", ";\n\tpadding: ", " ", ";\n\ttransition: all 0.3s;\n\tline-height: 1;\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttext-align: center;\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n\n\t&:hover {\n\t\ttext-decoration: none;\n\t}\n\n\t&:disabled {\n\t\topacity: 0.6;\n\t\tcursor: not-allowed;\n\t\tbackground-color: ", " !important;\n\t\tborder-color: ", " !important;\n\t\tcolor: ", " !important;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Wrapper = _styledComponents.default.span(_templateObject(), function (props) {
  return props.showMargin ? '1rem' : '0';
});

Wrapper.displayName = 'Wrapper';
var Button = (0, _react.forwardRef)(function (_ref, ref) {
  var loading = _ref.loading,
      children = _ref.children,
      secondary = _ref.secondary,
      gaAction = _ref.gaAction,
      tick = _ref.tick,
      Component = _ref.as,
      x = _ref.outline,
      props = _objectWithoutPropertiesLoose(_ref, ["loading", "children", "secondary", "gaAction", "tick", "as", "outline"]);

  return _react.default.createElement(Component, _extends({
    "data-track-action": gaAction
  }, props, {
    ref: ref
  }), _react.default.createElement(Wrapper, {
    showMargin: loading || tick
  }, loading && _react.default.createElement(_InlineLoader.default, {
    isLoading: loading
  }), tick && _react.default.createElement(_Tick.default, {
    size: 16,
    color: "inherit"
  })), children);
});
Button.displayName = 'Button';
var BaseButton = (0, _styledComponents.default)(Button)(_templateObject2(), _vars.default.borderRadius, _spacing.default.s1, _spacing.default.s2, _colors.default.grey, _colors.default.grey, _colors.default.white);
BaseButton.displayName = 'BaseButton';
Button.propTypes = {
  loading: _propTypes.bool,
  children: _propTypes.node.isRequired,
  secondary: _propTypes.bool,
  gaAction: _propTypes.string,
  tick: _propTypes.bool,
  as: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  outline: _propTypes.bool
};
Button.defaultProps = {
  gaAction: '',
  loading: false,
  secondary: false,
  tick: false,
  as: 'button',
  outline: false
};
/** @component */

var _default = BaseButton;
exports.default = _default;